import { router } from 'expo-router';
import {
    BodySmallRegular,
    Button,
    ButtonSize,
    ButtonVariant,
    H5Regular,
    Icon,
    MailIcon,
    View,
    YStack,
} from 'smoothie';

import LogRocketFacade from '../../../logger/log-rocket/LogRocketFacade';

const ForgotPasswordFinish = () => {
    LogRocketFacade.tagPage('ForgotPasswordFinish');

    return (
        <YStack
            marginHorizontal={20}
            marginTop={82}
            flex={1}
            alignItems="center"
        >
            <YStack width={282} gap={8} alignItems="center" marginBottom={98}>
                <View padding={16}>
                    <Icon icon={MailIcon} size={32} color="$black" />
                </View>

                <H5Regular>Check your email</H5Regular>

                <BodySmallRegular textAlign="center" color="$gray1000">
                    If that email is in our system, we&apos;ll send instructions
                    to reset your password.
                </BodySmallRegular>
            </YStack>

            <Button
                variant={ButtonVariant.PRIMARY}
                size={ButtonSize.LARGE}
                text="Ok, got it"
                onPress={() => {
                    router.navigate('/sign-in/email');
                }}
            />
        </YStack>
    );
};

export default ForgotPasswordFinish;
